// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class RemoveSiteRequestModel {
    static getAttributeTypeMap() {
        return RemoveSiteRequestModel.attributeTypeMap;
    }
}
RemoveSiteRequestModel.discriminator = undefined;
RemoveSiteRequestModel.attributeTypeMap = [
    {
        "name": "siteId",
        "baseName": "siteId",
        "type": "number"
    }
];
//# sourceMappingURL=removeSiteRequestModel.js.map